import { el } from "../ui/dom";
import { icon } from "../ui/icons";
import type { Me } from "../shell/types";

// Home (mockup): a greeting with today's date on the company's clock (brief 1E-8), then one card per section the person can
// open, each with an Open button. Numbers and the inbox arrive with the modules' own briefs.

function greeting(now: Date, zone: string): string {
  const hour = Number(
    new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      hour: "numeric",
      hourCycle: "h23",
    }).format(now),
  );
  return hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
}

export function homeScreen(host: HTMLElement, me: Me, go: (path: string) => void) {
  const now = new Date();
  const date = new Intl.DateTimeFormat("en-US", {
    timeZone: me.timeZone,
    weekday: "long",
    month: "long",
    day: "numeric",
  }).format(now);
  const first = me.user.name.split(/\s+/)[0] ?? me.user.name;
  const sections = me.menus.filter((m) => m.top);

  host.append(
    el(
      "div",
      { class: "head" },
      el(
        "div",
        { class: "t" },
        el("div", { class: "eyebrow" }, "Home"),
        el("h1", {}, `${greeting(now, me.timeZone)}, ${first}`),
        el("div", { class: "muted" }, `${date} · ${me.company.name}`),
      ),
    ),
  );

  if (sections.length === 0) {
    host.append(
      el(
        "div",
        { class: "blank" },
        icon("circle-slash", "big"),
        el("h2", {}, "Nothing to open yet"),
        el(
          "p",
          { class: "muted" },
          "No role on this account includes a screen yet. Ask the office for a role.",
        ),
      ),
    );
    return;
  }

  host.append(
    el(
      "div",
      { class: "wsgrid" },
      ...sections.map((m) => {
        const open = el(
          "button",
          { type: "button", class: "btn pri sm", "aria-label": `Open ${m.name}` },
          icon("eye"),
          " Open",
        );
        open.addEventListener("click", () => go(`/${m.id}/overview`));
        return el(
          "section",
          { class: "card ws" },
          el(
            "div",
            { class: "top2" },
            el("div", {}, el("div", { class: "eyebrow" }, m.brand), el("h2", {}, m.name)),
            open,
          ),
          el("p", { class: "muted small" }, m.blurb),
        );
      }),
    ),
  );
}
